import { ErrorBoundary } from '@sentry/react'
import { FunctionComponent, ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import CardErrorCosmos, {
  CardErrorCosmosTitle,
} from '@/components/common/card/card-error-cosmos'

export interface KolDetailSectionProps {
  header: {
    title: string
    anchor: {
      id: string
      offset: number
    }
    extraContent?: ReactNode
  }
  children: ReactNode
}

const KolDetailSection: FunctionComponent<KolDetailSectionProps> = ({
  header,
  children,
}) => {
  return (
    <>
      <Anchor id={header.anchor.id} offset={header.anchor.offset} />
      <Box>
        <Header>
          <Title>{header.title}</Title>
          {header.extraContent}
        </Header>
        <ErrorBoundary
          beforeCapture={(scope): void => {
            scope.setTag('card-cosmos', true)
          }}
          fallback={({ resetError }): ReactElement => (
            <ErrorCosmos onReset={resetError} />
          )}
        >
          <DataBlockContainer>{children}</DataBlockContainer>
        </ErrorBoundary>
      </Box>
    </>
  )
}

const Box = styled.div`
  width: 100%;
  padding-top: 20px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`

const Anchor = styled.div<{ offset: number }>`
  pointer-events: none;
  transform: ${({ offset }): string => `translateY(${-offset}px)`};
`

const Title = styled.div`
  color: ${({ theme }): string => theme.colors.gray10};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`

const DataBlockContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(24, minmax(0, 1fr));
  grid-auto-rows: auto;
  gap: 30px;
`

const ErrorCosmos = styled(CardErrorCosmos)`
  border-radius: 4px;
  box-shadow: 0 0 12px 0 rgb(0, 0, 0, 0.04);
  background: ${({ theme }): string => theme.colors.white};
  gap: 50px;

  ${CardErrorCosmosTitle} {
    margin-bottom: 10px;
  }
`

export default KolDetailSection
